export default function slotButton(slot) {
  const startTime = new Date(slot.UtcDate);
  const endTime = new Date(startTime.getTime() + slot.Duration * 60000);
  const slotsDayFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: slot.SpecTimezoneIANAId,
    weekday: 'short',
  });
  const slotsDateFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: slot.SpecTimezoneIANAId,
    timeStyle: 'short',
  });

  if (slot.IsTourableNow) {
    return `
    <li>
        <button type="button" class="nhs-c-datepicker__button nhs-c-datepicker__button--now" data-slot="${slot.Date}" data-slot-button>
         <span class="nhs-o-typography--sans-body-1-medium-medium">Tour now</span>
        </button>
    <li>
    `;
  }
  return `<li>
        <button type="button" class="nhs-c-datepicker__button" data-slot="${slot.Date}" data-slot-button>
          <div class="nhs-o-typography--sans-label-1-xxx-small-medium-uppercase">
              ${(slotsDayFormat.format(startTime))}
          </div>
          <div class="nhs-c-datepicker__time nhs-u-flex-column">
              <span class="nhs-o-typography--sans-body-1-medium-medium">
              ${slotsDateFormat.format(startTime)}
              </span>
              <span class="nhs-o-typography--sans-label-1-xxx-small-medium-uppercase">to</span>
              <span class="nhs-o-typography--sans-body-1-medium-medium">
              ${slotsDateFormat.format(endTime)}
              </span>
           </div>
        </button>
    <li>`;
}
